import gql from 'graphql-tag';

export const getExpertoBannerPreference = gql`
  query getExpertoBannerPreferenceGet($userId: ID!) {
    expertoBannerPreferences(
      userId: $userId
    ) {
      id
      showBanner
      updatedAt
    }
  }
`;
